import React, { Component, Fragment } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { Table } from 'reactstrap'
import styled from 'styled-components'
import ContentService from '../services/content'
import { connect } from 'react-redux'
import { __ } from '../services/translate'
import { selectArticlesForLanguage, selectLicenceNumbers } from '../utils/selectors/content'
import { clearSearch } from '../actions/app'
import LicenceModal from '../components/LicenceModal'

class Search extends Component {

  state = {
    results: [],
    modalOpen: false,
  }

  static getDerivedStateFromProps(props) {
    return {
      results: ContentService.search(props.q, props.articles, props.selectedCountry, props.userLicences)
    }
  }

  componentWillUnmount() {
    // this.props.clearSearch()
  }

  toggleModal = () => this.setState({ modalOpen: !this.state.modalOpen })

  render() {
    if (this.state.results.length === 0) {
      return <h1>{__("Nenašli se žádne vysledky pro výraz")} "{this.props.q}"</h1>
    }

    return (
      <Fragment>
        {this.state.modalOpen && <LicenceModal onClose={this.toggleModal}/>}
        <h1>{__("Vysledky pro výraz")} "{this.props.q}"</h1>
        <Table>
          <tbody>
          {
            this.state.results.map((result, idx) => (
              <ResultRow
                key={idx}
                disabled={result.disabled}
                onClick={() => result.disabled ? this.toggleModal() : null}
              >
                <td>
                  <h4>
                    {
                      result.disabled ? (
                        <span>
                          <i className="fa fa-lock"/>
                          &nbsp;
                          {result.article.name}
                        </span>
                      ) : (
                        <Link to={result.url}>{result.article.name}</Link>
                      )
                    }
                  </h4>
                  <div>
                    <small>{result.path}</small>
                  </div>
                </td>
              </ResultRow>
            ))
          }
          </tbody>
        </Table>
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  articles: selectArticlesForLanguage(state.content.articles, state.locale.selectedLanguage.id),
  selectedCountry: state.locale.selectedCountry,
  q: state.app.searchQuery,
  userLicences: selectLicenceNumbers(state.user)
})

const mapDispatchToProps = (dispatch) => ({
  clearSearch: () => dispatch(clearSearch()),
})

const ResultRow = styled.tr`
  background: ${props => props.disabled ? 'rgba(255, 0, 0, .2)' : 'transparent'};
`

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Search))
